import { getLocale } from '@helpers/locale';
import { getConfiguration } from '@helpers/utils';
import Resources from '@helpers/resources';

export const getAssignmentPreviewUrl = (assignmentId) => {
  const baseUrl = getConfiguration('UPFBaseUrl');
  const { authToken } = Resources.env;
  const locale = getLocale();

  const url = new URL(baseUrl);
  url.searchParams.set('authToken', authToken);
  url.searchParams.set('assignmentId', assignmentId);
  url.searchParams.set('locale', locale.toString());
  url.searchParams.set('isPreview', 'true');
  url.searchParams.set('newContent', 'true');

  return url.toString();
};

export default getAssignmentPreviewUrl;



// WEBPACK FOOTER //
// ./components/learning-journey/helpers.js